import { render, staticRenderFns } from "./Frota.vue?vue&type=template&id=6862c8e0&"
import script from "./Frota.vue?vue&type=script&lang=js&"
export * from "./Frota.vue?vue&type=script&lang=js&"
import style0 from "vue-multiselect/dist/vue-multiselect.min.css?vue&type=style&index=0&prod&lang=css&"
import style1 from "./Frota.vue?vue&type=style&index=1&id=6862c8e0&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports